<template>
  <div class="block bg-bg py-64 sm:py-70">
    <div class="container xxl:px-24">
      <div
        class="product-content mx-auto flex lg:w-2/3"
        :class="{
          'lg:w-1/2': component.contentType === 'content',
          'lg:w-2/3': component.contentType === 'image',
        }"
      >
        <ProductSpot
          v-if="product"
          class="flex-shrink-0 editorial-product-spot"
          :class="{
            'mb-24 sm:mb-0': component.contentType === 'content',
          }"
          :product="product"
          :index="0"
          :list-title="componentTitle"
        />
        <div
          class="w-full sm:w-1/2 sm:pl-16 lg:w-auto lg:pl-48 md:w-full relative flex"
          :class="{
            'items-center': component.contentType === 'content',
            'items-start order-first sm:order-last':
              component.contentType === 'image',
          }"
        >
          <div
            v-if="component.contentType === 'content'"
            class="wysiwyg sm:-mt-144"
            v-html="component.content"
          />
          <nuxt-img
            v-else-if="component.image"
            :src="component.image"
            preset="standard"
            sizes="mob375:100vw mob390:100vw mob414:100vw desk:349px"
            class="mb-24 h-440 w-full object-cover sm:mb-0 lg:h-620"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useCartStore } from '~/store/cart';
import ComponentBlock from '~/models/component-block';
import Product from '~/models/product';
import ProductSpot from '~/components/productlist/ProductSpot.vue';
import { useUiStore } from '~/store/ui';

const uiStore = useUiStore();

const cartStore = useCartStore();
const { fetchProduct } = useProductService();

const props = defineProps<{
  component: ComponentBlock,
}>();

const product = ref<Product | null>(null);
const hasSentProductImpression = ref(false);

const currencyCode = computed(() => {
  return cartStore.cartData.currency;
});
const componentTitle = computed(() => {
  return props.component.title || props.component.layout;
});

onMounted(()=> {
  getProduct();
});

const getProduct = async() => {
  try {
    const { ecomData, contentData } = await fetchProduct(props.component.product.ecom_id);

    product.value = new Product({ ecomData, contentData });
  } catch (e) {
    console.error(e);
    uiStore.setError(e.response.status);
  }
};

</script>
<style lang="postcss">
.product-content {
  .editorial-product-spot.product-spot-regular {
    @apply w-full;
    @screen sm {
      @apply w-1/2;
    }

    @screen md {
      @apply w-300;
    }
  }

  @media (max-width: 640px) {
    flex-wrap: wrap;
  }
}
</style>
